const DEGREE_OPTIONS = [
  {
    value: "bac_plus_2",
    description: "Bac +2 (a two-year post-secondary diploma)",
  },
  {
    value: "bac_plus_3",
    description: "Bac +3 (bachelor's degree)",
  },
  {
    value: "master_or_phd",
    description: "Master's degree or PhD",
  },
  {
    value: "3_years_experience",
    description: "3 years of experience in the same sector of activity",
  },
];

const TITLE_OPTIONS = [
  {
    value: "mr",
    description: "Mr",
  },
  {
    value: "ms",
    description: "Ms",
  },
];
const MARITAL_STATUS_OPTIONS = [
  {
    value: "single",
    description: "Single",
  },
  {
    value: "married",
    description: "Married",
  },
  {
    value: "divorced",
    description: "Divorced",
  },
  {
    value: "separated",
    description: "Separated",
  },
  {
    value: "widowed",
    description: "Widowed",
  },
];

const RESIDENT_CARD_TYPE_OPTIONS = [
  {
    value: "vie_privee_et_familiale",
    description: "Vie privée et familiale",
  },
  {
    value: "salarie",
    description: "Salarié",
  },
  {
    value: "etudiant",
    description: "Étudiant",
  },
  {
    value: "entrepreneur_profession_liberale",
    description: "Entrepreneur/Profession Libérale",
  },
  {
    value: "passeport_talent",
    description: "Passeport Talent",
  },
  {
    value: "travailleur_temporaire",
    description: "Travailleur temporaire",
  },
  {
    value: "carte_de_resident_passeport_talent",
    description: "Carte pluriannuelle Passeport Talent",
  },
  {
    value: "carte_de_resident_etudiant",
    description: "Carte pluriannuelle Étudiant",
  },
  {
    value: "carte_de_resident_salarie",
    description: "Carte pluriannuelle Salarié",
  },
  {
    value: "carte_de_resident_de_10_ans",
    description: "Carte de Résident de 10 ans",
  },
  {
    value: "carte_de_resident_longue_duree_ue",
    description: "Carte de Résident Longue Durée – UE",
  },
  {
    value: "eu_blue_card",
    description: "EU Blue Card",
  },
  {
    value: "other",
    description: "Other",
  },
];

export {
  DEGREE_OPTIONS,
  TITLE_OPTIONS,
  MARITAL_STATUS_OPTIONS,
  RESIDENT_CARD_TYPE_OPTIONS,
};
